import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  plans_type: {
    type: 'string',
  },
  plans_city_code: {
    type: 'string',
  },
  ...Common,
};
